import mock from './mockAdapter';

import './headerData';
// import './budgetItems'; // Enabled for testing
// import './urbanAssets'; // Enabled for testing
// import './workOrdersRoutes'; // Enabled for testing
import './orderTypes'; // Enabled for testing
import { setupRequestItemsRoutes } from './requestItemsRoutes'; // Request items routes

// Setup request items routes
setupRequestItemsRoutes(mock);

mock.onAny().passThrough();
